import Arrow  from '@/components/buttons/Arrow'
import cn     from 'classnames'
import Link   from 'next/link'
import styles from './LinkWithArrow.module.sass'

const LinkWithArrow = ({
	href,
	children,
	className = null,
	arrowType = 'horizontal',
	arrowVariant = 'normal',
	...props
}) => {
	return (<Link
		href={href}
		className={cn(styles.link_with_arrow, className)}
		{...props}
	>
		{arrowType === 'horizontal' ? <Arrow
			className={styles.arrow}
			variant={arrowVariant}
		/> : arrowType === 'diagonal' ? <Arrow
			type={'diagonal'}
			className={styles.arrow}
			variant={arrowVariant}
		/> : null}
		<div className={styles.content}>
			{children}
		</div>
	</Link>)
}

export default LinkWithArrow
